import graphql from './graphql';
import courseSetEnterpriseType from './Request/Course_SetEnterpriseType';

/**
 * Cursos publicados con la marca de "obligatorio para toda la empresa".
 *
 * La terminal no viaja: un curso definido a nivel empresa vale igual en todas,
 * así que la columna repetía el mismo valor en cada fila.
 */
const mapCourses = coursesEnterprise =>
  coursesEnterprise.map(course => ({
    id: course.id,
    name: course.name || '',
    duration: course.duration || 0,
    categoryName: course.CourseCategory?.name || 'sin categoría',
    isChecked: Boolean(course.isChecked),
  }));

export const fetch = async () => {
  const data = await graphql(
    'Course_listCoursesByEnterprise',
    'name duration CourseCategory {name} isChecked id',
    'query'
  ).catch(() => ({ Course_listCoursesByEnterprise: [] }));

  return { coursesByEnterprises: mapCourses(data.Course_listCoursesByEnterprise) };
};

// TO-DO: Verify courses to be added aren't already assigned to department/job title
export const update = async coursesData => courseSetEnterpriseType(coursesData);
